<template>
  <div class="agent-permissions">
    <header class="agent-permissions__header row align-middle collapse">
      <span class="agent-permissions__header-title columns">
        {{ $t('AGENT.PERMISSIONS.PERMISSION_TYPE') }} {{ title }}
      </span>
      <ElButton
        type="text"
        class="columns shrink agent-permissions__select-btn"
        @click="selectOrDeselectAll"
      >
        {{ selectAllText }}
      </ElButton>
    </header>
    <div class="agent-permissions__list scrollbar">
      <AgentPermissionsItem
        v-for="perm in permissions"
        :key="perm.property"
        :title="perm.title"
        :description="perm.description"
        :value="perm.value"
        @input="value => emitValue(value, perm.property)"
      />
    </div>
  </div>
</template>

<script>
import AgentPermissionsItem from './AgentPermissionsItem';

export default {
  name: 'AgentPermissions',
  components: {
    AgentPermissionsItem,
  },
  props: {
    permissions: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      allSelected: false,
    };
  },
  computed: {
    selectAllText() {
      return this.allSelected
        ? this.$t('AGENT.PERMISSIONS.DESELECT_ALL')
        : this.$t('AGENT.PERMISSIONS.SELECT_ALL');
    },
  },
  methods: {
    selectOrDeselectAll() {
      this.allSelected = !this.allSelected;
      if (this.allSelected) this.$emit('selectAll');
      else this.$emit('deselectAll');
    },
    emitValue(value, property) {
      this.$emit('change', {
        value,
        property,
      });
    },
  },
};
</script>

<style lang="scss">
.agent-permissions {
  height: 100%;
  min-height: rem-calc(300px);
  display: flex;
  flex-direction: column;

  &__header {
    border-bottom: 1px solid $lb-light-gray;

    padding-bottom: calc($global-margin / 2);

    &-title {
      font-size: rem-calc(17px);
      font-weight: bold;
    }
  }

  &__list {
    flex: 1 0 0;
    overflow-y: auto;
  }

  &__select-btn {
    font-size: rem-calc(13px);
  }
}
</style>
